var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81975 20.8801C4.45975 20.8801 4.21975 20.7601 3.97975 20.5201C3.49975 20.0401 3.49975 19.3201 3.97975 18.8401L19.3398 3.48012C19.8198 3.00012 20.5398 3.00012 21.0198 3.48012C21.4998 3.96012 21.4998 4.68012 21.0198 5.16012L5.65975 20.5201C5.41975 20.7601 5.17975 20.8801 4.81975 20.8801Z",
    fill: "#858894"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1798 20.8801C19.8197 20.8801 19.5798 20.7601 19.3398 20.5201L3.97975 5.16012C3.49975 4.68012 3.49975 3.96012 3.97975 3.48012C4.45975 3.00012 5.17975 3.00012 5.65975 3.48012L20.8998 18.7201C21.3798 19.2001 21.3798 19.9201 20.8998 20.4001C20.7798 20.7601 20.4198 20.8801 20.1798 20.8801Z",
    fill: "#858894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.40e609f6f79a36bc9d841ad7aec4d99d.svg";
export { ForwardRef as ReactComponent };